import css from 'styled-jsx/css';

export default css`
  .features-block-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: #141414;
    padding: 0 35px;
    text-align: start;
    transition: all 0.3s ease-in-out;
    border: 1px solid transparent;
    border-radius: 5px;
    font-family: 'Roboto-Normal';
    font-size: 20px;
    font-weight: 600;
  }
  .features-block-title:hover {
    border: 1px solid #950810;
  }
  .features-block-icon {
    display: none;
  }
  .features-block-icon-active {
    transition: all 0.4s ease-in-out;
    transform: rotate(90deg);
  }
  @media (max-width: 767px) {
    .features-block-title {
      padding: 0 20px;
      gap: 20px;
      font-size: 13px;
    }
    .features-block-icon {
      display: block;
    }
  }
  .red-border {
    border: 1px solid #950810;
  }
`;
